import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../../api";

import ParadigmaLabeledInput from "../../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"
import ParadigmaEditor from "../../../../components/ParadigmaEditor/ParadigmaEditor.js"

class Modal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: null,
            descripcion: "",
            cuerpo: "",
            asunto: "",
            postVariables: ['descripcion', 'cuerpo', 'asunto'],
            errors: [],
         };
    }

    static propTypes = {
        onSubmit: PropTypes.func,
        id: PropTypes.func,
        action: PropTypes.oneOf(['CREATE', 'EDIT', 'DETAIL', 'DELETE']).isRequired,
    }


    resetForm() {
        this.setState({
            id: null,
            descripcion: "",
            cuerpo: "",
            asunto: "",
            errors: [],
        });
    }

    getData() {
        const { postVariables } = this.state;
        let data = {};
        postVariables.forEach(x => {
            data[x] = this.state[x];
        });

        return data;
    }

    setData(data) {
        if (data.success) {
            this.setState({
                id: data.id,
                descripcion: data.descripcion,
                cuerpo: data.cuerpo,
                asunto: data.asunto,
            })
        }
    }

    setErrors(errors) {
        this.setState({
            errors: errors,
        });
    }

    onChangeField(field, value) {
        this.setState(prevState => {
            let errors = prevState.errors;
            if (errors) errors[field] = null;
            prevState.errors = errors;
            prevState[field] = value;
            return prevState;
        });
    }

    getError(field) {
        let errors = this.state.errors;
        if (errors) return errors[field];
        else return null;
    }

    modalVars() {
        const { action } = this.props;
        if (action == "CREATE") {
            return {
                get: false,
                submitType: "POST",
                title: "Nueva Plantilla",
                buttonTitle: "Nuevo",
                danger: false,
                buttonIcon: "fa fa-plus fa-lg",
                successMessage: "La Plantilla ha sido creado con éxito.",
                saveButton: true,
                saveButtonLabel: "Guardar",
                buttonClass: "",
                disabled: false,
            };
        } else if (action == "EDIT") {
            return {
                get: true,
                submitType: "PUT",
                title: "Editar Plantilla",
                buttonTitle: "Editar",
                danger: false,
                buttonIcon: "fa fa-pencil fa-lg",
                successMessage: "La Plantilla ha sido editado con éxito.",
                saveButton: true,
                saveButtonLabel: "Guardar",
                buttonClass: "",
                disabled: false,
                id: this.props.id,
            };
        } else if (action == "DETAIL") {
            return {
                get: true,
                submitType: null,
                title: "Plantilla",
                buttonTitle: "Ver",
                danger: false,
                buttonIcon: "fa fa-search fa-lg",
                successMessage: "",
                saveButton: false,
                buttonClass: "",
                disabled: true,
                id: this.props.id,
            };
        } else if (action == "DELETE") {
            return {
                get: true,
                submitType: "DELETE",
                title: "Eliminar Plantilla",
                buttonTitle: "Eliminar",
                danger: true,
                buttonIcon: "fa fa-trash fa-lg",
                successMessage: "La Plantilla ha sido eliminado con éxito.",
                saveButton: true,
                saveButtonLabel: "Eliminar",
                buttonClass: "btn-danger",
                disabled: true,
                id: this.props.id,
            };
        }
    }

    onCuerpoChange = html => this.setState({ cuerpo: html });

    render() {
        let vars = this.modalVars();
        const fieldClassNames = ["ui-field-label-col", "ui-field-control-col"];

        return (
            <ParadigmaModal
                getUrl={(vars.get ? api.mails.plantillas : null)}
                submitUrl={(vars.submitType ? api.mails.plantillas : null)}
                submitType={vars.submitType}
                id={vars.id}
                onGotData={(data) => this.setData(data)}
                onGotErrors={(errors) => this.setErrors(errors)}
                onSubmit={(e) => this.props.onSubmit(e)}
                onClose={() => this.resetForm()}
                onPreSubmit={() => this.getData()}

                title={vars.title}

                danger={vars.danger}
                buttonClass={vars.buttonClass}

                successMessage={vars.successMessage}
                missingIdMessage={"Debe seleccionar una fila."}
                saveButtonLabel={vars.saveButtonLabel}
                buttonTitle={vars.buttonTitle}
                buttonIcon={vars.buttonIcon}
                saveButton={vars.saveButton}
                closeButton={true}
                className="ui-paradigma-modal ui-paradigma-modal-wide"
            >
                <section className="ui-modal-section">
                    <p className="ui-section-label">Datos de la plantilla</p>
                    <div className="ui-form-grid">
                        <ParadigmaLabeledInput
                            disabled={vars.disabled}
                            md={[12, 12]}
                            classNames={fieldClassNames}
                            maxLength={255}
                            label={"Descripción"}
                            value={this.state.descripcion}
                            onChange={(e) => this.onChangeField('descripcion', e.target.value)}
                            error={() => this.getError('descripcion')}
                        />
                        <ParadigmaLabeledInput
                            disabled={vars.disabled}
                            md={[12, 12]}
                            classNames={fieldClassNames}
                            maxLength={100}
                            label={"Asunto"}
                            value={this.state.asunto}
                            onChange={(e) => this.onChangeField('asunto', e.target.value)}
                            error={() => this.getError('asunto')}
                        />
                    </div>
                </section>

                <section className="ui-modal-section">
                    <p className="ui-section-label">Contenido del mail</p>
                    <label>Cuerpo</label>
                    <div className="ui-editor-shell">
                        <ParadigmaEditor
                            disabled={vars.disabled}
                            value={this.state.cuerpo}
                            onChange={this.onCuerpoChange}
                        />
                    </div>
                </section>
            </ParadigmaModal>
        );
    }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/views/Configuracion/Mails/Plantillas/Modal.js